module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"toolbar_title":"Unternehmensdaten","save":"Speichern","cancel":"Abbrechen"},"en":{}}')
  delete Component.options._Ctor
}
